module.exports = {"days":"DAYS","hours":"HOURS","minutes":"MINS","seconds":"SECS"}